export default __webpack_public_path__ + "static/media/office-1920px.1a6cbe20.jpg";